import { computed } from "vue";
import { useStore } from "vuex";

import { columns, options } from "@/helpers/sectionsTableHelper";

export default function useSectionsTable() {
  const store = useStore();

  const tableData = computed(() => store.getters["utilities/getSections"]);

  const tableOptions = {
    ...options,
  };

  return {
    columns,
    tableData,
    tableOptions,
  };
}
